<template>
	<div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb page-title="Deductions" />
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
					<!-- <button
						type="button"
						class="btn btn-success btn-with-shadow"
						@click="exportAll"
					>
						{{ $t("export_all") }}
					</button> -->
					<button
						type="button"
						class="btn btn-primary btn-with-shadow"
						data-toggle="modal"
						:disabled="isProcessed || isView"
						@click="openAddEditModal"
					>
						{{ $t("add") }}
					</button>
				</div>
			</div>
		</div>
		<hr style="border-top: 2px solid black; font-weight: bold; margin-bottom: 20px !important;" />
		<app-table :id="tableId" :options="options" @action="getListAction" />

		<!-- <app-add-modal
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:selected-url="selectedUrl"
			@close-modal="closeAddEditModal"
		/> -->

		<fees-notice-details-deductions-table-form
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:form-id="formId"
			:row-data="rowData"
			:selected-url="selectedUrl"
			:invoiceRequestId="invoiceRequestId"
			@close-modal="closeAddEditModal"
		/>

		<app-delete-modal
			v-if="deleteConfirmationModalActive"
			:preloader="deleteLoader"
			modal-id="demo-delete"
			@confirmed="confirmed"
			@cancelled="cancelled"
		/>
	</div>
</template>

<script>
import CoreLibrary from "../../../../../../../../core/helpers/CoreLibrary.js";
import { FeesNoticesDetailsDeductionsTableSchema } from "./FeesNoticesDetailsDeductionsTableSchema";
import { urlGenerator } from "../../../../../../../Helpers/AxiosHelper";

export default {
	extends: CoreLibrary,
	name: "FeesNoticeDetailsDeductionsTable",
	mixins: [FeesNoticesDetailsDeductionsTableSchema],
	props: {
		invoiceRequestId: {
			type: Number,
		},
		isProcessed: {
			type: Boolean,
		},
		isView: {
			type: Boolean,
		}
	},
	created() {
		this.options.columns = [...this.tableColumns];
	},
	methods: {
		/**
		 * for open add edit modal
		 */
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},

		/**
		 * for close add edit modal
		 */
		closeAddEditModal() {
			$("#fees-notice-details-deductions-table-form").modal("hide");
			this.isAddEditModalActive = false;
			this.reSetData();
		},

		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;

			if (actionObj.title == "Delete") {
				this.openDeleteModal();
			} else if (actionObj.title == this.$t("edit")) {
				this.selectedUrl = `${this.Endpoint}/${rowData.id}`;
				this.openAddEditModal();
			} else if (actionObj.title != "Delete" || actionObj.title != this.$t("edit")) {
                this.selectedUrl = `${this.Endpoint}/${rowData.id}`;
                this.openAddEditModal();
            }
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},

		/**
		 * confirmed $emit Form confirmation modal
		 */
		confirmed() {
			let url = `${this.Endpoint}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.cancelled();
					this.$toastr.s(response.data.message);
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
				});
		},

		/**
		 * cancelled $emit Form confirmation modal
		 */
		cancelled() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		exportAll() {
			window.location.replace(urlGenerator(DATATABLE_EXPORT));
		},
	},
};
</script>
